export enum RelationSourceType {
  SelfService = 'SelfService',
  DELI = 'DELI',
  OMDB = 'OMDB',
}

export enum PersonSubtype {
  Award = 'award',
  certificate = 'certificate',
  Internal = 'Internal',
  PaytoPlay = 'Pay to Play',
  VendorPartnerProgram = 'Vendor Partner Program',
}

export enum PersonDataSourceId {
  // TMDB = 1001,
  // OMDB = 2001,
  // GVD = 3001,
  // DELI = 4001,
  TMDB = 'TMDB',
  OMDB = 'OMDB',
  GVD = 'GVD',
  DELI = 'DELI',
  HUBSPOT = 'HUBSPOT',
}

export enum PersonSource {
  Client = 'Client',
  Vitrina = 'Vitrina',
}
